import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import { injectIntl } from 'react-intl';
import { MdOutlineContactPhone } from 'react-icons/md';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import ContactSidebar from '@interness/web-core/src/components/structure/ContactSidebar/ContactSidebar';
import SEO from '@interness/web-core/src/components/modules/SEO/SEO';
import ContactForm from '@interness/web-core/src/components/modules/ContactForm/ContactForm';
import { Link } from '@interness/web-core/src/components/elements';
import ContactMap from '@interness/web-core/src/components/media/ContactMap';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ContactPage = props => {
  const intl = props.intl.formatMessage;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
    title: 'Kontakt'
  }), ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(Heading, {
    icon: ___EmotionJSX(MdOutlineContactPhone, null)
  }, "Pers\xF6nlicher Kontakt"), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX(Flex, {
    flexWrap: "wrap"
  }, ___EmotionJSX(Box, {
    width: ['100%', '50%', '50%', '50%']
  }, ___EmotionJSX("h3", null, "Info"), ___EmotionJSX(ContactSidebar, null), ___EmotionJSX(Spacer, {
    height: 20
  })), ___EmotionJSX(Box, {
    width: ['100%', '50%', '50%', '50%']
  }, ___EmotionJSX(ContactForm, null))), ___EmotionJSX(Spacer, null), ___EmotionJSX("div", null, ___EmotionJSX("p", null, intl({
    id: 'pages.contact.privacyApproval1'
  }), ___EmotionJSX(Link, {
    to: intl({
      id: 'pages.contact.privacyLink'
    })
  }, intl({
    id: 'pages.contact.privacyLinkName'
  })), intl({
    id: 'pages.contact.privacyApproval2'
  }))), ___EmotionJSX(Spacer, null)), ___EmotionJSX(ContactMap, null));
};
export default injectIntl(ContactPage);